import React from "react";
import styles from "./styles.module.scss";
import { SpaceMembersModel } from "./indexModel";
import { Loading } from "app/components/Wrappers";
import SpaceMembersList from "./SpaceMembersList";
import SearchBar from "app/components/inputs/SearchBar";
import SpaceMembersInvite from "./SpaceMembersInvite";
import SpaceMemberInviteModal from "./SpaceMemberInviteModal";
import { useTranslation } from "react-i18next";

const SpaceMembers = () => {
  const { t } = useTranslation();

  const {
    loading,
    members,
    membersRef,
    invitedMembers,
    invitedMembersRef,
    onMakeAthlete,
    onRemoveUser,
    memberSearchHandler,
    onMemberInvite,
    onCopyLink,
    onEdit,
    onResend,
    invitationError,
    isRefreshingLists,
    handleInviteModal,
    inviteModalIsOpen,
    inviteUrl,
  } = SpaceMembersModel();

  return (
    <>
      <div className={styles.container}>
        <SpaceMembersInvite
          onMemberInvite={onMemberInvite}
          invitationError={invitationError}
        />
        {!isRefreshingLists && invitedMembers && invitedMembers.length > 0 && (
          <SpaceMembersList
            label={t("Invitations")}
            testId="space-invitations-list"
            members={invitedMembers}
            containerRef={invitedMembersRef}
            onEdit={onEdit}
            onResend={onResend}
            onCopyLink={onCopyLink}
            onRemoveUser={onRemoveUser}
          />
        )}
        <label>{t("Find by Name")}</label>
        <SearchBar
          className={styles.search}
          placeholder={t("Enter member name")}
          onChange={memberSearchHandler}
        />
        {isRefreshingLists ? (
          <div data-testid="space-members-refreshing">
            <Loading isLoading loadType="spinner" />
          </div>
        ) : (
          <>
            {loading && !members.length && (
              <Loading isLoading={loading} loadType="spinner" />
            )}
            <SpaceMembersList
              label={t("Members")}
              testId="space-members-list"
              members={members}
              onMakeAthlete={onMakeAthlete}
              onRemoveUser={onRemoveUser}
              containerRef={membersRef}
              onEdit={onEdit}
              onResend={onResend}
              onCopyLink={onCopyLink}
            />
            {loading && members.length > 0 && (
              <Loading isLoading={loading} loadType="spinner" />
            )}
          </>
        )}
      </div>
      {inviteModalIsOpen && (
        <SpaceMemberInviteModal
          isOpen={inviteModalIsOpen}
          onClose={handleInviteModal}
          url={inviteUrl}
        />
      )}
    </>
  );
};

export default SpaceMembers;
